// extracted by mini-css-extract-plugin
export default {"CardRound":"cadr-round_CardRound__s1IOX","CardRound__logo":"cadr-round_CardRound__logo__dJA9K","CardRound__text":"cadr-round_CardRound__text__W3Wrg"};